export const contractTypes = {
  arrangementTrip: "手配旅行",
};
